module.exports = __webpack_public_path__ + "img/LCA's-img.7a26ad45.svg";